import classNames from 'classnames';
import { observer } from 'mobx-react';

import * as style from '../messages_shared.module.less';
import { SideChatMessage } from '@assets/model/SideChatStore';
import React from 'react';
import { useStoreUI } from '@assets/model/Store';
import { ModalShowMessageThinking } from '@assets/component/ModalShowMessageThinking/ModalShowMessageThinking';

export const MessageReasoningFooter = observer(
    (props: { m: SideChatMessage; children: React.ReactNode }) => {
        const { m, children } = props;
        const showLog = m && m.thinking && m.thinking.length > 0;
        return (
            <details
                style={{ position: 'relative' }}
                className={classNames(
                    'collapsible-wrapper',
                    style.reasoningText
                )}
            >
                <summary>
                    Reasoning
                    <div
                        style={{ visibility: showLog ? 'visible' : 'hidden' }}
                        className={style.messageDetailsButton}
                        onClick={e => {
                            e.stopPropagation();
                            e.preventDefault();

                            if (m && m.thinking) {
                                const ui = useStoreUI();
                                ui.modal = {
                                    title: 'Log',
                                    el: <ModalShowMessageThinking m={m} />
                                };
                            }
                        }}
                    >
                        Log
                    </div>
                </summary>
                <div className="collapsible-content" />
                <div className={classNames('item', style.reasoningText)}>
                    {children}
                </div>
            </details>
        );
    }
);
